import Splide from '@splidejs/splide';

function carousel() {
    const carouselCards = document.querySelectorAll('.splide--carousel');

    carouselCards.forEach((item) => {
        const splide = new Splide(item, {
            drag: true,
            autoWidth: true,
            pagination: true,
            arrows: false,
            type: 'loop',
            focus: 'center',
            // perPage: 3,
            // perMove: 1,
            // padding: { left: 100, right: 100 },
            gap: 30,
            speed: 600, // Velocidad de transición consistente
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)', // Easing suave
            rewind: false, // Evita recalculo al volver
            waitForTransition: false, // NO espera a que termine la transición
            updateOnMove: false, // NO actualiza durante movimiento
            trimSpace: false, // NO recorta espacio extra
            breakpoints: {
                1024: {
                    autoWidth: false,
                    perPage: 1,
                    perMove: 1,
                    padding: { left: 150, right: 150 },
                    gap: 15
                },
                768: {
                    perPage: 1,
                    perMove: 1,
                    padding: { left: 80, right: 80 },
                    gap: 15
                },
                576: {
                    perPage: 1,
                    perMove: 1,
                    padding: { left: 30, right: 30 },
                    gap: 15
                }
            }
        });

        splide.mount();
    });
}

export default carousel;